const UPDATE_EVENT_TYPES = new Set([
  "WORK_ORDER_UPDATED",
  "WORK_ORDER_NOTE_UPDATED",
  "WORK_ORDER_PO_UPDATED",
]);

export const formatEventLabel = (logType, eventLabel, fields) => {
  if (!UPDATE_EVENT_TYPES.has(logType) || !fields) return eventLabel;
  const fieldList = fields
    .split(",")
    .map((f) => f.trim())
    .filter(Boolean);
  if (fieldList.length === 0) return eventLabel;
  if (fieldList.length === 1) return `${fieldList[0]} Updated`;
  if (fieldList.length <= 3) return `${fieldList.join(", ")} Updated`;
  return `${fieldList.slice(0, 2).join(", ")} +${fieldList.length - 2} more Updated`;
};

export const fieldsFromChanges = (changes) =>
  Array.isArray(changes)
    ? changes
        .map((c) => c?.field)
        .filter(Boolean)
        .join(",")
    : "";
